module.exports = __webpack_public_path__ + "static/media/gb-nir.8f2e0707.jpeg";